/**
 * Converts Pinecone cosine similarity (0-1) to a 0-100 score.
 */
export function normalizeCosineSimilarity(rawScore: number): number {
  return Math.round(Math.max(0, Math.min(1, rawScore)) * 100);
}
